import { useStrictContext } from '@/hooks/useStrictContext'
import { ShowResolvedCtx } from '../context'

export const useShowResolved = () =>
  useStrictContext(ShowResolvedCtx, 'ShowResolvedCtx')
